import ShiftsViewComponent from "../components/ShiftsView";
import useShiftsView from "../hooks/useShiftsView";

const ShiftsView = () => {
  const useShiftsViewProps = useShiftsView();
  return <ShiftsViewComponent {...useShiftsViewProps} />;
};

export default ShiftsView;
